<template>
   <div class="posts-box u-margin-t-40">
                <div class="posts-box__top">
                    <h4 class="posts-box__top__title">Video</h4>
                </div>

                <div class="video-player">
                    <div class="row">
                        <div class="col-lg-7 video-column">
                            <div class="video-player__frame">
                                <youtube :video-id="this.$youtube.getIdFromUrl(videoBox.lastVideoUrl)" ref="youtube"></youtube>
                            </div>
                        </div><!--// col-8 end -->
                        <div class="col-lg-5">
                            <div class="video-player__play-list">

                                <div class="play-list__header">
                                    <h4><span>Video vijesti</span></h4>
                                    <a v-bind:href="videoBox.youTubeChannel" class="btn-subscription u-borderRadius4" target="_blank">Pretplati se</a>
                                </div>
                                <ul class="play-lists">
                                    <v-bar v-if="videoBox.videoPosts" wrapper="wrapper">
                                    <li v-for="(post, i) in videoBox.videoPosts" :key="i">
                                        <figure class="video-thumb">
                                          <router-link :to="{ name: 'read', params: { category: post.categoryCode, slug: post.searchCode, id: post.postID }}"><img v-lazy="post.absoluteThumbUrl" v-bind:alt="post.title"></router-link>
                                        </figure>
                                        <div class="video-content">
                                            <h6> <router-link :to="{ name: 'read', params: { category: post.categoryCode, slug: post.searchCode, id: post.postID }}">{{ getPostTitle(post) }}</router-link></h6>
                                            <span class="date">{{ post.postDate | timeAgo }}</span>
                                        </div>   
                                        </li> 
                                     </v-bar>
                                </ul> 
                            </div>
                        </div>
                    </div>
                </div>

            </div>
</template>

<script>
    import { NewsService } from '../common/api.service'
    import VBar from 'v-bar'

    export default {
        name: "VideoBox",
        components: { VBar  },
        data() {
            return {
                videoBox: {}
            }
        },
        created() {
            this.fetchData();
        },
        methods: {
            fetchData: function() {
                 NewsService.getVideoBoxInfo(0,10)
                             .then(res => 
                             { 
                                 this.videoBox = res.data;
                             });
            },
            getPostTitle(post) {
                if(post.title.length < 40)
                    return post.title;
                else if(post.shortTitle) {
                    if(post.shortTitle.length < 40)
                        return post.shortTitle;
                    else 
                        return post.shortTitle.slice(0,37)+"...";
                }
                else 
                   return post.title.slice(0,37)+"...";
            }
        }
    }
</script>

<style scoped>
    .video-player {
         border-right: 1px solid #eae9e9;
         border-bottom: 1px solid #eae9e9;
         border-left: 1px solid #eae9e9;
    }
    .video-player__play-list .play-lists {
        height:270px;
        padding-right: 0px;
        overflow-y: hidden;
    }

    .video-player__play-list .play-lists li {
        margin-bottom: 0px;
    }

    .video-column {
        padding-left: 6px;
        padding-right: 0px;
    }

     .wrapper {
        height: inherit;
    }
</style>



// WEBPACK FOOTER //
// src/components/VideoBox.vue